import React from "react";
import { any, arrayOf, objectOf, shape, string } from "prop-types";

import { List, ListItem, ListItemLink, Title } from "../Dropdown";

const LinksList = ({ linkProps, linksList, title }) => {
  const getKey = (item, ind) =>
    item?.title && item?.link ? `${item.title}_${item.link}` : ind;
  return linksList?.length ? (
    <>
      <Title>{title}</Title>
      <List hasBottomPadding>
        {linksList.map((item, ind) => (
          <ListItem key={getKey(item, ind)}>
            <ListItemLink href={item.link} {...linkProps}>
              {item.title}
            </ListItemLink>
          </ListItem>
        ))}
      </List>
    </>
  ) : null;
};

LinksList.propTypes = {
  linksList: arrayOf(
    shape({
      title: string,
      link: string
    })
  ),
  title: string,
  linkProps: objectOf(any)
};

LinksList.defaultProps = {
  linksList: [],
  title: "",
  linkProps: {}
};

export default LinksList;
